import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {observable, computed, makeObservable} from 'mobx';

import FormLabel from './form-label';

@observer
export default class SelectInput extends React.Component {

  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ]),
    onChange: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    required: PropTypes.bool,
    labelText: PropTypes.string,
    labelIsSrOnly: PropTypes.bool,
    helperText: PropTypes.string,
    optionsList: PropTypes.array,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    className: PropTypes.string,
    announceError: PropTypes.bool
  }

  static defaultProps = {
    optionsList: [],
    labelText: '',
    helperText: '',
    labelIsSrOnly: false,
    required: false,
    disabled: false,
    errorMessage: 'Please select one of the options.',
    className: ''
  }

  @observable hasVisibleError = false;

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  @computed get hasFunctionalError() {
    return this.props.required && !this.props.value;
  }

  handleOnChange = (e) => {
    this.props.onChange(this.props.id, e.target.value);
    this.hasVisibleError = this.hasFunctionalError;
  }

  handleOnBlur = () => {
    this.hasVisibleError = this.hasFunctionalError;
  }

  render() {
    return (
      <div className={`form-group ${this.props.className} ${this.hasVisibleError ? 'has-error' : ''}`}>
        <FormLabel
          htmlFor={this.props.id}
          hasError={this.hasVisibleError}
          fieldIsRequired={this.props.required}
          labelText={this.props.labelText}
          labelIsSrOnly={this.props.labelIsSrOnly}
          helperText={this.props.helperText}
          errorMessage={this.props.errorMessage}
          announceError={this.props.announceError}/>
        <select
          className="form-control form-control-lg"
          ref={i => this.input = i}
          id={this.props.id}
          onChange={this.handleOnChange}
          onBlur={this.handleOnBlur}
          value={this.props.value}
          disabled={this.props.disabled}>
          {this.props.placeholder &&
            <option value="">
              {this.props.placeholder}
            </option>
          }
          {this.props.optionsList.map(option => {
            const uniqueValue = option.value || option.title;
            return (
              <option value={uniqueValue} key={uniqueValue}>
                {option.title}
              </option>
            )
          })}
        </select>
      </div>
    )
  }
}
